import { render, staticRenderFns } from "./NsAlert.vue?vue&type=template&id=99e9f792&scoped=true&"
import script from "./NsAlert.vue?vue&type=script&lang=js&"
export * from "./NsAlert.vue?vue&type=script&lang=js&"
import style0 from "./NsAlert.vue?vue&type=style&index=0&id=99e9f792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e9f792",
  null
  
)

export default component.exports